import { filter, map, type Observable, tap } from 'rxjs';
import { openOKDialog } from '@pct-ng/feature-message-material';
import { messageDialogOptionsGenerator } from '../../message-dialog-options-generator';
import type { MaintenanceModeError } from './maintenance-mode.error';

export function handleMaintenanceModeError(
  i18nScope: string,
  i18nReloadKey: string,
  error: MaintenanceModeError,
): Observable<MaintenanceModeError> {
  return openOKDialog(
    messageDialogOptionsGenerator(`${i18nScope}.MAINTENANCE_MODE`),
    i18nReloadKey,
  ).pipe(
    map(() => error),
    tap(() => window.location.reload()),
    filter(() => false),
  );
}
